import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[scep-func]',
    standalone: false
})
export class ScepFuncDirective {
    constructor(public viewContainerRef: ViewContainerRef) { }
}